import Footer from '@/components/Footer';
import Header from '@/components/Header';
import { Box, ThemeProvider, theme } from '@everlywell/ui-kit';
import React from 'react';
import GlobalStyle from 'styles/global';
import { NotificationProvider } from 'utils/contexts';

type Props = {
  children: React.ReactNode;
};

const Layout = ({ children }: Props) => (
  <Box id="app" className="siteRoot" style={{ position: 'relative' }}>
    <GlobalStyle />
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <Header />
        {children}
        <Footer />
      </NotificationProvider>
    </ThemeProvider>
  </Box>
);

export default Layout;
